import {observer} from 'mobx-react';
import {Layout} from 'shared/components';
import {TimeTrackingSubnav} from 'main/containers/time_tracking';

const DimensionsContainer = observer(({scope}) => {
  return (
    <div>
      <TimeTrackingSubnav scope={scope}/>
      <Layout/>
    </div>
  );
});

export default DimensionsContainer;
